import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkspacePremiumOutlined } from '../icons';
import './PlanTabButton.css';

// Só aparece pra quem está no plano gratuito — quem já é assinante não
// precisa ver o convite pra assinar de novo. Fica junto dos outros botões de
// .tabs-buttons (ver MyMocks.js) mas navega pra fora da tela de Simulados,
// em vez de trocar de aba.
function PlanTabButton({ hasFreePlan }) {
  const navigate = useNavigate();

  if (!hasFreePlan) return null;

  return (
    <button
      type="button"
      className="tab-button plan-tab-button"
      onClick={() => navigate('/planos')}
    >
      <WorkspacePremiumOutlined style={{ fontSize: 18, verticalAlign: 'middle', marginRight: 6 }} />
      Planos
    </button>
  );
}

export default PlanTabButton;
